// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type CanBeAnything = any

export interface BoardedAccountList {
  accountId: string
  accountName: string
  status: number
}

export interface BoardedTableData extends BoardedAccountList {
  cta: string
  statusType: string
}

export interface AnalyzeDataEntity {
  deliveredCampaignInsights: number
  deliveredCampaignOptimizationAnalysis: number
  deliveredEOCRReports: number
  deliveredLiveReports: number
  deliveredPCAReports: number
  scheduledCampaignInsights: number
  scheduledCampaignOptimizationAnalysis: number
  scheduledEOCRReports: number
  scheduledLiveReports: number
  scheduledPCAReports: number
}

export enum BusinessManagerStatus {
  all = 'All',
  unmapped = 'Unmapped',
  mapped = 'Mapped',
  in_progress = 'In Progress',
}

export enum DeboardTypes {
  FACEBOOK_PAGES = 'PAGE',
  DATASET = 'DATASET',
  CATALOG = 'CATALOG',
  INSTAGRAM_ACCOUNTS = 'IGACCOUNT',
  ACCOUNT = 'ADACCOUNT',
}

export interface TokenHealthTable {
  category: string
  customToken: string
  tokenStatus: TokenStatus | null
  lastChecked: string
  errorHoverText?: string
  name?: string
}

export enum TokenStatus {
  ERROR = 'Error',
  HEALTHY = 'Healthy',
  NA = '-',
}
